import { CALL_API } from '../middleware/ApiMiddleware';

export const NOTICE_LIST_FETCH_REQUEST = 'NOTICE_LIST_FETCH_REQUEST';
export const NOTICE_LIST_FETCH_SUCCESS = 'NOTICE_LIST_FETCH_SUCCESS';
export const NOTICE_LIST_FETCH_FAILURE = 'NOTICE_LIST_FETCH_FAILURE';

export const NOTICE_FETCH_REQUEST = 'NOTICE_FETCH_REQUEST';
export const NOTICE_FETCH_SUCCESS = 'NOTICE_FETCH_SUCCESS';
export const NOTICE_FETCH_FAILURE = 'NOTICE_FETCH_FAILURE';

export const NOTICE_EDIT_REQUEST = 'NOTICE_EDIT_REQUEST';
export const NOTICE_EDIT_SUCCESS = 'NOTICE_EDIT_SUCCESS';
export const NOTICE_EDIT_FAILURE = 'NOTICE_EDIT_FAILURE';

export const NOTICE_CREATE_REQUEST = 'NOTICE_CREATE_REQUEST';
export const NOTICE_CREATE_SUCCESS = 'NOTICE_CREATE_SUCCESS';
export const NOTICE_CREATE_FAILURE = 'NOTICE_CREATE_FAILURE';

export const NOTICE_EDIT_SEQUENCE_REQUEST = 'NOTICE_EDIT_SEQUENCE_REQUEST';
export const NOTICE_EDIT_SEQUENCE_SUCCESS = 'NOTICE_EDIT_SEQUENCE_SUCCESS';
export const NOTICE_EDIT_SEQUENCE_FAILURE = 'NOTICE_EDIT_SEQUENCE_FAILURE';

export const SET_NOTICE_ID_SUCCESS = 'SET_NOTICE_ID_SUCCESS';

export const VERIFY_NOTICE_MERGE_CODES_REQUEST = 'VERIFY_NOTICE_MERGE_CODES_REQUEST';
export const VERIFY_NOTICE_MERGE_CODES_SUCCESS = 'VERIFY_NOTICE_MERGE_CODES_SUCCESS';
export const VERIFY_NOTICE_MERGE_CODES_FAILURE = 'VERIFY_NOTICE_MERGE_CODES_FAILURE';

export const FETCH_NOTICE_BY_VIOLATION_TYPE_REQUEST = 'FETCH_NOTICE_BY_VIOLATION_TYPE_REQUEST';
export const FETCH_NOTICE_BY_VIOLATION_TYPE_SUCCESS = 'FETCH_NOTICE_BY_VIOLATION_TYPE_SUCCESS';
export const FETCH_NOTICE_BY_VIOLATION_TYPE_FAILURE = 'FETCH_NOTICE_BY_VIOLATION_TYPE_FAILURE';
export const NOTICE_PREVIEW_REQUEST = 'NOTICE_PREVIEW_REQUEST';
export const NOTICE_PREVIEW_SUCCESS = 'NOTICE_PREVIEW_SUCCESS';
export const NOTICE_PREVIEW_FAILURE = 'NOTICE_PREVIEW_FAILURE';

const formsURL = 'xerce/config/notices';
const noticesByViolationTypeURL = 'xerce/config/suggest-notices';
const previewNoticeURL = 'xerce/preview-notice';

export const fetchNotices = () => ({
  [CALL_API]: {
    endpoint: formsURL,
    method: 'get',
    authenticated: true,
    types: [NOTICE_LIST_FETCH_REQUEST, NOTICE_LIST_FETCH_SUCCESS, NOTICE_LIST_FETCH_FAILURE],
  },
});

export const fetchNotice = (noticeId: number) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/${noticeId}`,
    method: 'get',
    authenticated: true,
    types: [NOTICE_FETCH_REQUEST, NOTICE_FETCH_SUCCESS, NOTICE_FETCH_FAILURE],
  },
});

export const editNotice = (noticeId: number, noticeEditRequest: IConfigXerceNoticeRequest) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/${noticeId}`,
    method: 'put',
    body: noticeEditRequest,
    authenticated: true,
    types: [NOTICE_EDIT_REQUEST, NOTICE_EDIT_SUCCESS, NOTICE_EDIT_FAILURE],
  },
});

export const createNotice = (noticeCreateRequest: IConfigXerceNoticeRequest) => ({
  [CALL_API]: {
    endpoint: formsURL,
    method: 'post',
    body: noticeCreateRequest,
    authenticated: true,
    types: [NOTICE_CREATE_REQUEST, NOTICE_CREATE_SUCCESS, NOTICE_CREATE_FAILURE],
  },
});

export const editNoticeSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [NOTICE_EDIT_SEQUENCE_REQUEST, NOTICE_EDIT_SEQUENCE_SUCCESS, NOTICE_EDIT_SEQUENCE_FAILURE],
  },
});

export const verifyNoticeMergeCodes = (noticeId: number) => ({
  [CALL_API]: {
    endpoint: `${formsURL}/${noticeId}/merge-codes`,
    method: 'get',
    authenticated: true,
    types: [VERIFY_NOTICE_MERGE_CODES_REQUEST, VERIFY_NOTICE_MERGE_CODES_SUCCESS, VERIFY_NOTICE_MERGE_CODES_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchNoticesByViolationType = (violationTypeIds: number[], type: string) => ({
  [CALL_API]: {
    endpoint: noticesByViolationTypeURL,
    method: 'post',
    body: { violationTypeIds, type },
    authenticated: true,
    types: [
      FETCH_NOTICE_BY_VIOLATION_TYPE_REQUEST,
      FETCH_NOTICE_BY_VIOLATION_TYPE_SUCCESS,
      FETCH_NOTICE_BY_VIOLATION_TYPE_FAILURE,
    ],
  },
});

export const setNoticeId = (currentNoticeId: number) => ({
  type: SET_NOTICE_ID_SUCCESS,
  currentNoticeId,
});

export const previewNotice = (noticePreviewRequest: IConfigNoticePreviewRequest) => ({
  [CALL_API]: {
    endpoint: previewNoticeURL,
    method: 'post',
    body: noticePreviewRequest,
    authenticated: true,
    types: [NOTICE_PREVIEW_REQUEST, NOTICE_PREVIEW_SUCCESS, NOTICE_PREVIEW_FAILURE],
  },
});
